import React from 'react';
import { useLocation, Link } from 'react-router-dom';

interface LocationState {
  error?: string;
  code?: string;
}

const Error: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Ha ocurrido un error
            </h2>
            {state?.error && (
              <p className="text-sm text-gray-600 mb-4">
                {state.error}
              </p>
            )}
            {state?.code && (
              <p className="text-xs text-gray-500 mb-6">
                Código de error: {state.code}
              </p>
            )}
            <div className="mt-6">
              <Link
                to="/"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Volver al inicio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;